import axios from 'axios';

/**
 * get Home
 */
export const getHome = data => axios.$callAPI(() => axios.get('home/get', { params: data }));
